import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shouldShowHomeDownloadCta } from '../mobile/progress/installPrompt';

const Home = () => {
  const [showDownload, setShowDownload] = useState(false);

  useEffect(() => {
    setShowDownload(shouldShowHomeDownloadCta());
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center',
      padding: '2rem',
      paddingTop: '27.82vh',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      position: 'relative',
    }}>
      <h1 style={{
        fontSize: '3.5rem',
        color: '#333',
        marginBottom: '1.5rem',
        fontWeight: '700',
        letterSpacing: '-1px'
      }}>
        LGL PORTAL
      </h1>
      <div style={{
        width: '80px',
        height: '4px',
        backgroundColor: '#dc3545',
        marginBottom: '2rem'
      }}
      />
      <h2 style={{
        fontSize: '1.75rem',
        color: '#555',
        fontWeight: '300',
        maxWidth: '800px',
        lineHeight: '1.4'
      }}>
        One single platform to manage the whole organization
      </h2>
      <Link
        to="/actual-spent"
        aria-label="Enter time"
        title="Enter time"
        style={{
          position: 'absolute',
          left: 24,
          bottom: 24,
          width: 52,
          height: 52,
          borderRadius: '50%',
          backgroundColor: '#dc3545',
          color: '#fff',
          boxShadow: '0 4px 16px rgba(220, 53, 69, 0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          zIndex: 5,
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <polyline points="12 7 12 12 15.5 14" />
        </svg>
      </Link>
      {showDownload ? (
        <>
          <Link
            to="/download-app"
            style={{
              marginTop: '2rem',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 52,
              padding: '0 22px',
              borderRadius: 14,
              background: '#c62828',
              color: '#fff',
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Download the app
          </Link>
          <p style={{ marginTop: 12, color: '#777', fontSize: 14, maxWidth: 360 }}>
            Install LGL Portal on this phone or tablet (Android APK or iOS Add to Home Screen).
          </p>
        </>
      ) : null}
    </div>
  );
};

export default Home;
